import type { EnumUnion } from "@dresscode-frontend/utility-types";
import type { GetProxyUserListItem } from "../../../-types";

export const ProxyUserTableColumns = {
  LOGIN_ID: "LOGIN_ID",
  MATCH_TYPE: "MATCH_TYPE",
  PERSON: "PERSON",
  WORKER_TYPE: "WORKER_TYPE",
  WORKER_STATUS: "WORKER_STATUS",
  WORKER_CONTRACT_TYPE: "WORKER_CONTRACT_TYPE",
  EMPLOYMENT_TYPE: "EMPLOYMENT_TYPE",
  BOARD_MEMBER_TYPE: "BOARD_MEMBER_TYPE",
  CONTRACTOR_TYPE: "CONTRACTOR_TYPE",
  COLLABORATOR_TYPE: "COLLABORATOR_TYPE",
  GROUP_TYPE: "GROUP_TYPE",
  APPS: "APPS",
} as const;
export type ProxyUserTableColumns = EnumUnion<typeof ProxyUserTableColumns>;

type IdManagementTablePersonColumn = GetProxyUserListItem["person"];
type IdManagementTableAppColumn = GetProxyUserListItem["apps"][number];

export type ProxyUserTableRow = {
  [ProxyUserTableColumns.LOGIN_ID]: string;
  [ProxyUserTableColumns.MATCH_TYPE]: string;
  [ProxyUserTableColumns.PERSON]: IdManagementTablePersonColumn;
  [ProxyUserTableColumns.WORKER_TYPE]: string;
  [ProxyUserTableColumns.WORKER_STATUS]: string;
  [ProxyUserTableColumns.WORKER_CONTRACT_TYPE]: string;
  [ProxyUserTableColumns.EMPLOYMENT_TYPE]: string;
  [ProxyUserTableColumns.BOARD_MEMBER_TYPE]: string;
  [ProxyUserTableColumns.CONTRACTOR_TYPE]: string;
  [ProxyUserTableColumns.COLLABORATOR_TYPE]: string;
  [ProxyUserTableColumns.APPS]: IdManagementTableAppColumn[];
};

export const convertProxyUserItemToTableRow = (
  item: GetProxyUserListItem,
): ProxyUserTableRow => {
  return {
    [ProxyUserTableColumns.LOGIN_ID]: item.loginId,
    [ProxyUserTableColumns.MATCH_TYPE]: item.person?.matchTypeLabel ?? "",
    [ProxyUserTableColumns.PERSON]: item.person,
    [ProxyUserTableColumns.WORKER_TYPE]: item.person?.workerTypeLabel ?? "",
    [ProxyUserTableColumns.WORKER_STATUS]: item.person?.statusLabel ?? "",
    [ProxyUserTableColumns.WORKER_CONTRACT_TYPE]:
      item.person?.workerContractTypeLabel ?? "",
    [ProxyUserTableColumns.EMPLOYMENT_TYPE]:
      item.person?.employmentTypeName ?? "",
    [ProxyUserTableColumns.BOARD_MEMBER_TYPE]:
      item.person?.boardMemberTypeName ?? "",
    [ProxyUserTableColumns.CONTRACTOR_TYPE]:
      item.person?.contractorTypeName ?? "",
    [ProxyUserTableColumns.COLLABORATOR_TYPE]:
      item.person?.collaboratorTypeName ?? "",
    [ProxyUserTableColumns.APPS]: item.apps,
  };
};
